import React from 'react';
import { Link } from "react-router-dom";
import WebediaFooterLogo from "./WebediaFooterLogo";
import { Instagram, Facebook } from 'lucide-react';

const Footer = () => {
    // השארנו רק את הקישורים ההכרחיים לניווט תחתון
    const footerLinks = {
        ניווט: [
            { name: 'בית', path: '/' },
            { name: 'עגלת פרויקטים', path: '/orders' },
            { name: 'הזמנה אישית', path: '/personalCustomization' }
        ],
        מידע_משפטי: [
            { name: 'הצהרת נגישות', path: '/accessibility' },
            { name: 'הצהרת פרטיות', path: '/privacy' },
            { name: 'תנאי שימוש', path: '/terms' }
        ]
    };

    return (
        <footer className="bg-primary text-secondary/90 pt-16 pb-8 border-t border-primary-light" dir="rtl">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                {/* חלק עליון של הפוטר: מותג וקישורים */}
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 lg:gap-8 mb-16">

                    {/* עמודה 1 (רחבה): אודות המותג בסגירה */}
                    <div className="md:col-span-5 lg:col-span-4 flex flex-col items-start">
                        <Link to="/" className="flex items-center gap-2 mb-6 group">
                            <span className="text-2xl font-bold tracking-wide text-surface">פומה</span>
                        </Link>
                        <p className="text-secondary/70 text-sm leading-relaxed mb-8 max-w-sm">
                            סטודיו לעיצוב ויצירה בעץ מלא. אנחנו מתרגמים את החזון שלכם לפריטים על-זמניים, עם דיוק חסר פשרות ואהבה אמיתית לחומר.
                        </p>

                        {/* רשתות חברתיות - אייקונים נקיים */}
                        <div className="flex gap-4">
                            <a
                                href="https://www.instagram.com/pumawoodworking/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-10 h-10 rounded-full border border-secondary/30 flex items-center justify-center text-secondary/70 hover:text-accent hover:border-accent transition-all duration-300"
                                aria-label="Instagram"
                            >
                                <Instagram size={18} />
                            </a>
                            <a
                                href="https://www.facebook.com/profile.php?id=61556785871965"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-10 h-10 rounded-full border border-secondary/30 flex items-center justify-center text-secondary/70 hover:text-accent hover:border-accent transition-all duration-300"
                                aria-label="Facebook"
                            >
                                <Facebook size={18} />
                            </a>
                        </div>
                    </div>

                    {/* עמודות הקישורים */}
                    <div className="md:col-span-7 lg:col-span-8 grid grid-cols-2 sm:grid-cols-3 gap-8">
                        {Object.entries(footerLinks).map(([title, links]) => (
                            <div key={title}>
                                <h3 className="text-sm font-bold tracking-widest text-surface uppercase mb-6">
                                    {title.replace('_', ' ')}
                                </h3>
                                <ul className="space-y-4">
                                    {links.map((link) => (
                                        <li key={link.path}>
                                            <Link
                                                to={link.path}
                                                className="text-sm text-secondary/70 hover:text-accent transition-colors duration-300 inline-block"
                                            >
                                                {link.name}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>

                </div>

                {/* חלק תחתון: זכויות יוצרים וקרדיט מפתח - ממורכז הרחק מאזורי הסכנה */}
                <div className="pt-8 border-t border-secondary/20 flex flex-col items-center justify-center gap-5">
                    {/* קרדיט הפיתוח */}
                    <div className="opacity-70 hover:opacity-100 transition-opacity duration-300">
                        <WebediaFooterLogo />
                    </div>

                    {/* זכויות יוצרים */}
                    <div className="text-center">
                        <p className="text-secondary/50 text-xs">
                            © {new Date().getFullYear()} סטודיו פומה לעבודות עץ. כל הזכויות שמורות.
                        </p>
                    </div>
                </div>

            </div>
        </footer>
    );
};

export default Footer;